// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"menu-fold"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M4.75 12L3 13.5625L3 10.4375L4.75 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 19L3 19M21 12L10 12M21 5H3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4.75 12L3 13.5625L3 10.4375L4.75 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MenuFoldIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'menu-fold',
    ref,
    icon: element,
  },
));

MenuFoldIcon.displayName = 'MenuFoldIcon';

export default MenuFoldIcon;
